import React from 'react';
import { Spin } from 'antd';
import useReduxState from '@portal/hooks/useReduxState';

interface SpinnerProps {
  size?: 'small' | 'default' | 'large';
  color?: string;
  className?: string;
}

const Spinner = ({ size = 'default', color, className }: SpinnerProps) => {
  const {
    theme: { currentTheme },
  } = useReduxState();

  const spinnerColor = color || currentTheme.primary;

  return (
    <Spin size={size} className={className} style={{ color: spinnerColor }} />
  );
};

export default Spinner;
